const checkActionHistory = () =>
  new Promise((resolve) => {
    const MAX_RETRIES = 12;
    let retries = 0;

    const attempt = () => {
      retries += 1;
      if (
        window.swellAPI &&
        window.swellAPI.getCustomerDetails().email !== undefined
      ) {
        window.swellAPI.refreshCustomerDetails(() => {
          const customerDetails = window.swellAPI.getCustomerDetails();
          if (customerDetails?.email || retries > MAX_RETRIES) {
            resolve(customerDetails);
          } else {
            // Call the function again after 0.5 seconds
            setTimeout(attempt, 500);
          }
        });
      } else {
        // Call the function again after 0.5 seconds
        setTimeout(attempt, 500);
      }
    };

    attempt();
  });

const checkActiveRedemptionOptions = () =>
  new Promise((resolve) => {
    const MAX_RETRIES = 8;
    let retries = 0;

    const attempt = () => {
      retries += 1;
      if (
        window.swellAPI &&
        window.swellAPI.getCustomerDetails().email !== undefined
      ) {
        window.swellAPI.refreshCustomerDetails(() => {
          const activeRedemptionOptions =
            window.swellAPI.getActiveRedemptionOptions();
          if (activeRedemptionOptions.length || retries > MAX_RETRIES) {
            resolve(activeRedemptionOptions);
          } else {
            // Call the function again after 0.5 seconds
            setTimeout(attempt, 500);
          }
        });
      } else {
        // Call the function again after 0.5 seconds
        setTimeout(attempt, 500);
      }
    };

    attempt();
  });

const getBestLoyaltyRedemption = async () => {
  const customerDetails = await checkActionHistory();
  const activeRedemptionOptions = await checkActiveRedemptionOptions();

  let currentRedemptionOption;
  let nextRedemptionOption;
  let isFinalOption = false;
  let isFirstOption = false;
  if (customerDetails && activeRedemptionOptions?.length > 0) {
    const { pointsBalance } = customerDetails;

    // Sort the options by cost in descending order
    const sortedOptions = activeRedemptionOptions
      .sort((a, b) => b.costInPoints - a.costInPoints)
      .filter((item) => item.discountType !== 'product');
    // Find the current redemption option
    currentRedemptionOption = sortedOptions.find(
      (option) => option.costInPoints <= pointsBalance,
    );

    if (!currentRedemptionOption) {
      // Last option is the first option (cheapest option)
      isFirstOption = true;
      return {
        currentRedemptionOption: null,
        nextRedemptionOption: sortedOptions[sortedOptions.length - 1],
        isFinalOption: false,
        isFirstOption: true,
        pointsBalance: customerDetails?.pointsBalance,
      };
    }

    // Find the next redemption option
    const currentIndex = sortedOptions.indexOf(currentRedemptionOption);
    nextRedemptionOption = sortedOptions[currentIndex - 1];

    // If there is no next option, set isFinalOption to true
    if (!nextRedemptionOption) {
      isFinalOption = true;
    }
  }

  return {
    currentRedemptionOption,
    nextRedemptionOption,
    isFinalOption,
    isFirstOption,
    pointsBalance: customerDetails?.pointsBalance,
  };
};

export default getBestLoyaltyRedemption;
